export const mockPreferencesLists = [{ id: 'a4fg', isActive: true }]